import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import Button from "../../../components/button";
import Input from "../../../components/input";
import { createOrUpdatePlan } from "../../../api/endpoint";
import toast from "react-hot-toast";
import axios from "axios";

const UpdateModal = ({
  isUpdateOpen,
  closeUpdateModal,
  selectedPlan,
  fetchPlans,
}) => {

  const [plan, setPlan] = useState({
    name: "",
    price: "",
    durationInDays: "",
  });
  const { auth } = useSelector((state) => state.login);

  useEffect(() => {
    setPlan({
      name: selectedPlan?.name,
      price: selectedPlan?.price,
      durationInDays: selectedPlan?.durationInDays
    })
  }, [selectedPlan])

  const updatePlan = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(createOrUpdatePlan, plan, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${auth}`,
        },
        params: {
          id: selectedPlan?.id,
        },
      });
      toast.success(response?.data?.message)
      fetchPlans();
      closeUpdateModal();
    } catch (err) {
      console.error("Login error:", err);
      toast.error('Error updating plan')
    }
  };

  return (
    <Modal show={isUpdateOpen} onHide={closeUpdateModal} centered>
      <Modal.Header closeButton>
        <Modal.Title>Update Subscription Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form>
          <Input
            label="Name"
            name="name"
            placeholder="Name"
            type="text"
            value={plan.name}
            onChange={(e) => setPlan({ ...plan, name: e.target.value })}
            className="mb-2"
          />
          <Input
            label="Price"
            name="price"
            placeholder="Price"
            type="text"
            value={plan.price}
            onChange={(e) => setPlan({ ...plan, price: e.target.value })}
            className="mb-2"
          />
          <Input
            label="Duration"
            name="price"
            placeholder="Duration"
            type="text"
            value={plan.durationInDays}
            onChange={(e) =>
              setPlan({ ...plan, durationInDays: e.target.value })
            }
            className="mb-2"
          />
          <div className="mt-3 text-center">
            <Button
              text="Update Subscription Plan"
              callBack={(e) => updatePlan(e)}
            />
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <Button text="Close" callBack={closeUpdateModal} />
      </Modal.Footer>
    </Modal>
  );
};

export default UpdateModal;
